import PropTypes from 'prop-types';

export const Icons = ({ testid, className, variant, onClick, color, svgClass }) => {
  const renderIcon = () => {
    switch (variant) {
      case Icons.NEW_SEARCH: {
        return (
          <svg
            width="52"
            height="52"
            viewBox="0 0 52 52"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M23 14.5C18.3056 14.5 14.5 18.3056 14.5 23C14.5 27.6944 18.3056 31.5 23 31.5C27.6944 31.5 31.5 27.6944 31.5 23C31.5 18.3056 27.6944 14.5 23 14.5ZM9.5 23C9.5 15.5442 15.5442 9.5 23 9.5C30.4558 9.5 36.5 15.5442 36.5 23C36.5 30.4558 30.4558 36.5 23 36.5C15.5442 36.5 9.5 30.4558 9.5 23Z"
              fill="#51BFE1"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M32.7678 29.2322L41.7678 38.2322C42.7441 39.2085 42.7441 40.7915 41.7678 41.7678C40.7915 42.7441 39.2085 42.7441 38.2322 41.7678L29.2322 32.7678C26.9524 30.4879 30.4879 26.9524 32.7678 29.2322Z"
              fill="#51BFE1"
            />
          </svg>
        );
      }

      case Icons.MY_SEARCH: {
        return (
          <svg
            width="52"
            height="52"
            viewBox="0 0 52 52"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.1666 15.5C15.1666 12.7386 17.4052 10.5 20.1666 10.5H31.8333C34.5947 10.5 36.8333 12.7386 36.8333 15.5V40C36.8333 40.5453 36.5374 41.0476 36.0604 41.312C35.5835 41.5763 35.0007 41.561 34.5383 41.272L26 35.9355L17.4616 41.272C16.9992 41.561 16.4164 41.5763 15.9395 41.312C15.4625 41.0476 15.1666 40.5453 15.1666 40V15.5Z"
              fill="#928CDA"
            />
          </svg>
        );
      }

      case Icons.TOURS: {
        return (
          <svg
            width="52"
            height="52"
            viewBox="0 0 52 52"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M36 9C36 7.89543 35.1046 7 34 7C32.8954 7 32 7.89543 32 9V9.60156H20V9C20 7.89543 19.1046 7 18 7C16.8954 7 16 7.89543 16 9V9.60156H15.2C12.1072 9.60156 9.59998 12.1088 9.59998 15.2016V36.8016C9.59998 39.8944 12.1072 42.4016 15.2 42.4016H36.8C39.8928 42.4016 42.4 39.8944 42.4 36.8016V15.2016C42.4 12.1088 39.8928 9.60156 36.8 9.60156H36V9ZM16 13V12.9998C15.686 13.4176 15.5 13.9371 15.5 14.5C15.5 15.8807 16.6193 17 18 17C19.3807 17 20.5 15.8807 20.5 14.5C20.5 13.9371 20.314 13.4176 20 12.9998V13C20 14.1046 19.1046 15 18 15C16.8954 15 16 14.1046 16 13ZM32 12.9998V13C32 14.1046 32.8954 15 34 15C35.1046 15 36 14.1046 36 13V12.9998C36.314 13.4176 36.5 13.9371 36.5 14.5C36.5 15.8807 35.3807 17 34 17C32.6193 17 31.5 15.8807 31.5 14.5C31.5 13.9371 31.686 13.4176 32 12.9998ZM13.6 36.8016V21.5H38.4V36.8016C38.4 37.6852 37.6836 38.4016 36.8 38.4016H15.2C14.3163 38.4016 13.6 37.6852 13.6 36.8016ZM22.3994 27.8008C21.2948 27.8008 20.3994 28.6962 20.3994 29.8008C20.3994 30.9053 21.2948 31.8008 22.3994 31.8008H29.5994C30.704 31.8008 31.5994 30.9053 31.5994 29.8008C31.5994 28.6962 30.704 27.8008 29.5994 27.8008H22.3994Z"
              fill="#4673D1"
            />
          </svg>
        );
      }

      case Icons.MATCHES: {
        return (
          <svg
            width="52"
            height="52"
            viewBox="0 0 52 52"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12 18.5C12 13.5294 16.0294 9.5 21 9.5C25.9705 9.5 30 13.5294 30 18.5C30 23.4706 25.9705 27.5 21 27.5C16.0294 27.5 12 23.4706 12 18.5Z"
              fill="#00B152"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M31.0213 10.2451C31.353 9.77127 31.9277 9.53044 32.4982 9.62614C36.7559 10.3405 40 14.0408 40 18.5018C40 22.9628 36.7559 26.6631 32.4982 27.3774C31.937 27.4715 31.3708 27.24 31.0364 26.7797C30.702 26.3193 30.6568 25.7093 30.9199 25.2047C32.4493 22.2707 33.1024 20.214 33.102 18.3203C33.1016 16.4417 32.4574 14.5159 30.9447 11.8446C30.6597 11.3413 30.6895 10.7189 31.0213 10.2451Z"
              fill="#00B152"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8.59009 38.7834C9.76628 34.8965 13.1386 31.375 17.2498 31.375H24.75C28.8611 31.375 32.2336 34.8964 33.4099 38.7834C33.9199 40.4689 32.5497 41.875 31.0598 41.875H10.9402C9.45022 41.875 8.08004 40.4689 8.59009 38.7834Z"
              fill="#00B152"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M33.4142 32.1925C33.6706 31.6908 34.1865 31.375 34.75 31.375C38.8611 31.375 42.2336 34.8964 43.4099 38.7834C43.9199 40.4689 42.5497 41.875 41.0598 41.875H38C37.2785 41.875 36.6593 41.3614 36.5259 40.6524C36.2415 39.1417 35.9456 38.0643 35.5129 37.0612C35.0796 36.0567 34.4826 35.065 33.5345 33.754C33.2043 33.2974 33.1579 32.6943 33.4142 32.1925Z"
              fill="#00B152"
            />
          </svg>
        );
      }

      case Icons.CLIENT_SEARCHES: {
        return (
          <svg
            width="52"
            height="52"
            viewBox="0 0 52 52"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M13 18.5C13 13.5294 17.0294 9.5 22 9.5C26.9705 9.5 31 13.5294 31 18.5C31 23.4706 26.9705 27.5 22 27.5C17.0294 27.5 13 23.4706 13 18.5Z"
              fill="#FB913A"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8.59009 38.7834C9.76628 34.8965 13.1386 31.375 17.2498 31.375H19.978C21.4015 31.375 22.4675 32.5362 22.4992 33.862C22.5544 36.1681 23.0359 37.4459 24.2977 39.6227C24.5667 40.0868 24.5675 40.6591 24.2997 41.1239C24.0319 41.5886 23.5363 41.875 23 41.875H10.9402C9.45022 41.875 8.08004 40.4689 8.59009 38.7834Z"
              fill="#FB913A"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M33.8393 29.75C31.5808 29.75 29.75 31.5808 29.75 33.8393C29.75 36.0977 31.5808 37.9286 33.8393 37.9286C36.0977 37.9286 37.9286 36.0977 37.9286 33.8393C37.9286 31.5808 36.0977 29.75 33.8393 29.75ZM25.75 33.8393C25.75 29.3717 29.3717 25.75 33.8393 25.75C38.3069 25.75 41.9286 29.3717 41.9286 33.8393C41.9286 38.3069 38.3069 41.9286 33.8393 41.9286C29.3717 41.9286 25.75 38.3069 25.75 33.8393Z"
              fill="#FB913A"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M36.8533 36.8553C37.6344 36.0743 38.9007 36.0743 39.6818 36.8553L44.6639 41.8375C45.445 42.6185 45.445 43.8848 44.6639 44.6659C43.8829 45.4469 42.6165 45.4469 41.8355 44.6659L36.8533 39.6837C36.0723 38.9027 36.0723 37.6364 36.8533 36.8553Z"
              fill="#FB913A"
            />
          </svg>
        );
      }

      case Icons.ACTIVITY: {
        return (
          <svg
            width="52"
            height="52"
            viewBox="0 0 52 52"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18.9159 11.7379C19.8177 8.10966 25.0163 8.23272 25.7454 11.8995L29.8501 32.5439L31.4379 26.1557C31.8257 24.5953 33.2267 23.4999 34.8345 23.4999H43C44.3807 23.4999 45.5 24.6192 45.5 25.9999C45.5 27.3806 44.3807 28.4999 43 28.4999H36.0073L33.0841 40.2616C32.1823 43.8898 26.9837 43.7668 26.2546 40.0999L22.1499 19.4556L20.5621 25.8441C20.1743 27.4044 18.7733 28.4999 17.1655 28.4999H9C7.61929 28.4999 6.5 27.3806 6.5 25.9999C6.5 24.6192 7.61929 23.4999 9 23.4999H15.9927L18.9159 11.7379Z"
              fill="#51BFE1"
            />
          </svg>
        );
      }

      case Icons.COMMENTS: {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M5.18229 16.0581L6.10236 16.4498L6.30022 15.9851L6.04365 15.5501L5.18229 16.0581ZM3.54135 19.912L2.62128 19.5203H2.62128L3.54135 19.912ZM4.18134 20.5744L4.54126 21.5074H4.54126L4.18134 20.5744ZM8.22693 19.0137L8.70902 18.1376L8.30125 17.9132L7.86701 18.0807L8.22693 19.0137ZM19.0781 12C19.0781 15.866 15.9441 19 12.0781 19V21C17.0487 21 21.0781 16.9706 21.0781 12H19.0781ZM12.0781 5C15.9441 5 19.0781 8.13401 19.0781 12H21.0781C21.0781 7.02944 17.0487 3 12.0781 3V5ZM5.07811 12C5.07811 8.13401 8.21212 5 12.0781 5V3C7.10755 3 3.07811 7.02944 3.07811 12H5.07811ZM6.04365 15.5501C5.43029 14.51 5.07811 13.2977 5.07811 12H3.07811C3.07811 13.6647 3.53101 15.2267 4.32093 16.5661L6.04365 15.5501ZM4.46142 20.3038L6.10236 16.4498L4.26222 15.6663L2.62128 19.5203L4.46142 20.3038ZM3.82142 19.6414C4.23373 19.4824 4.63454 19.8972 4.46142 20.3038L2.62128 19.5203C2.10191 20.7401 3.30435 21.9846 4.54126 21.5074L3.82142 19.6414ZM7.86701 18.0807L3.82142 19.6414L4.54126 21.5074L8.58685 19.9467L7.86701 18.0807ZM12.0781 19C10.8548 19 9.70754 18.687 8.70902 18.1376L7.74483 19.8898C9.03123 20.5977 10.5092 21 12.0781 21V19Z"
              fill="#928CDA"
            />
          </svg>
        );
      }

      case Icons.FAVORITES: {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M4.37884 13.2743C3.52487 12.3958 3 11.2029 3 9.88889C3 7.18883 5.21619 5 7.95 5C9.62414 5 11.1042 5.82084 12 7.07726C12.8958 5.82084 14.3759 5 16.05 5C18.7838 5 21 7.18883 21 9.88889C21 11.2674 20.4224 12.5126 19.4931 13.4013L13.4238 19.5561C12.6407 20.3503 11.3592 20.3504 10.5759 19.5564L4.37884 13.2743Z"
              stroke="#FF576D"
              strokeWidth="2"
            />
          </svg>
        );
      }

      case Icons.HIGHLIGHTS: {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
          >
            <g clipPath="url(#clip0_70781_56924)">
              <path
                d="M12.7343 17.8723C12.5886 17.7957 12.4146 17.7957 12.2689 17.8723L7.22641 20.5235C6.85959 20.7164 6.43086 20.4049 6.50093 19.9964L7.46418 14.3811C7.49201 14.2189 7.43823 14.0534 7.32039 13.9385L3.24118 9.96224C2.94441 9.67296 3.10819 9.16895 3.51833 9.10939L9.15546 8.29078C9.31833 8.26713 9.45914 8.16484 9.53197 8.01725L12.0533 2.90851C12.2367 2.53688 12.7666 2.53688 12.95 2.90851L15.4713 8.01725C15.5441 8.16484 15.6849 8.26713 15.8478 8.29078L21.4849 9.10939C21.8951 9.16895 22.0589 9.67296 21.7621 9.96224L17.6829 13.9385C17.565 14.0534 17.5112 14.2189 17.5391 14.3811L18.5023 19.9964C18.5724 20.4049 18.1437 20.7164 17.7768 20.5235L12.7343 17.8723Z"
                stroke="#FB913A"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_70781_56924">
                <rect width="24" height="24" fill="white" transform="translate(0.5)" />
              </clipPath>
            </defs>
          </svg>
        );
      }

      default:
        return null;
    }
  };
  return (
    <div testid={testid} onClick={onClick} className={className}>
      {renderIcon()}
    </div>
  );
};

Icons.NEW_SEARCH = 'newSearch';
Icons.MY_SEARCH = 'mySearch';
Icons.TOURS = 'tours';
Icons.MATCHES = 'matches';
Icons.CLIENT_SEARCHES = 'clientSearches';
Icons.ACTIVITY = 'activity';
Icons.COMMENTS = 'comments';
Icons.FAVORITES = 'favorites';
Icons.HIGHLIGHTS = 'highlights';

Icons.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.string,
  color: PropTypes.string,
  onClick: PropTypes.func,
  testid: PropTypes.string,
  svgClass: PropTypes.string,
};

Icons.defaultProps = {
  svgClass: '',
  className: '',
  variant: '',
  color: '',
  testid: undefined,
  onClick: () => {},
};
